import {  
    REGISTER_SUCCESS, 
    REGISTER_FAIL, 
    USER_LOADED, 
    ACCOUNT_LOADING,
    ACCOUNT_LOADING_DONE,
    GET_USER,
    UPDATE_AUTH,
    AUTH_ERROR, 
    USER_ERROR, 
    LOGIN_SUCCESS, 
    LOGIN_FAIL, 
    LOGOUT,
    CLEAR_USER,
    SET_STATUS
} from '../actions/types';

const initialState = {
    user_id: localStorage.getItem('user_id'), // Retrieve the user ID from local storage
    isAuthenticated: null, // Authentication status
    loading: true, // Loading status
    account_loading: false, // Creating Account Loading status
    user: null, // User data
    isPremium: false,
    error: {} // Error object
}

// Reducer function to manage authentication and user-related state
export default function(state = initialState, action) {
    const { type, payload } = action;

    switch(type) {
        case USER_LOADED:

            // Update state with user data when user is loaded
            return {
                ...state,
                isAuthenticated: true,
                loading: false,
                user: payload,
                user_id: payload._id ? payload._id : null
            }
        case ACCOUNT_LOADING:

            return {
                ...state,
                account_loading: true,
            }
        case ACCOUNT_LOADING_DONE:

            return {
                ...state,
                account_loading: false,
            }
        case GET_USER: 

            // Update state with modal user data
            return {
                ...state,
                user: action.payload,
                loading: false
            };
        case UPDATE_AUTH:

            // Update state with user data
            return {
                ...state,
                user: payload
            }
        case SET_STATUS: /** Used this name as a security measure, in case anyone can see redux events. */
            // Update state with user data
            return {
                ...state,
                isPremium: payload
            }
        case REGISTER_SUCCESS:
        case LOGIN_SUCCESS:
            
            // Update state with authentication and user data on successful registration/login
            return {
                ...state,
                ...payload,
                isAuthenticated: true,
                loading: false
            }
        case REGISTER_FAIL:
        case AUTH_ERROR:
        case LOGIN_FAIL:
        case LOGOUT:

            // Clear user data and set authentication status to false on registration/login failure or logout
            localStorage.removeItem('user_id');
            return {
                ...state,
                user_id: null,
                isAuthenticated: false,
                user: null,
                loading: false,
                isPremium: false
            }
        case CLEAR_USER:

            // Clear user data
            return {
                ...state,
                user: null,
                loading: false
            }
        case USER_ERROR:

            // Update state with user-related error
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}